import { FileText } from "lucide-react";
import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import { LEGAL_PAGES } from "../data/siteData";

export default function LegalPage({ pageKey }) {
  const page = LEGAL_PAGES[pageKey];

  return (
    <>
      <SEO title={`${page.title} | Sisal Store`} description={page.title} />
      <section data-testid={`legal-page-${pageKey}`} className="bg-slate-50 py-16 sm:py-24">
        <div className="container-x max-w-3xl">
          <Reveal>
            <p className="overline-tag">Informazioni</p>
            <h1 className="mt-3 font-display text-3xl font-extrabold uppercase leading-tight tracking-tight text-ink sm:text-4xl">
              {page.title}
            </h1>
            <div className="mt-10 rounded-3xl border border-dashed border-slate-300 bg-white p-8 sm:p-10">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-light text-brand-dark">
                <FileText className="h-6 w-6" />
              </span>
              {pageKey === "gioco-responsabile" && (
                <p className="mt-6 text-sm font-semibold leading-relaxed text-slate-700 sm:text-base">
                  Il gioco è vietato ai minori di 18 anni e può causare dipendenza patologica.
                </p>
              )}
              <p
                data-testid={`legal-placeholder-${pageKey}`}
                className="mt-6 text-sm leading-relaxed text-slate-500"
              >
                {page.placeholder}
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
